module.exports = __webpack_public_path__ + "img/hospitium-13.86f28053.jpg";